import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import timerStatusTypes from 'helpers/enums/timerStatusTypes'
import timeFormat from 'helpers/timeformat'

import styles from './countdown_timer.scss'

class CountdownTimer extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			animated: false,
			elapsed: 0,
			time_text: '00:00',
			color: 'grey',
		}
	}

	deanimate = () => {
		this.setState({
			animated: false,
		})
	}

	tick = () => {
		if (
			this.props.timer.state !== timerStatusTypes.RUNNING
			|| this.props.timer.remaining_time === 0
		) {
			return
		}

		const remainingTime = this.setCurrentCountdown()
		if (remainingTime > 0) {
			setTimeout(this.tick, 40)
		} else {
			this.props.onComplete()
		}
	}

	resumeCountdown() {
		this.initialTime = Date.now()
		this.tick()
	}

	stopCountdown() {
		this.initialTime = Date.now()
		this.setCurrentCountdown()
	}

	setCurrentCountdown() {
		const currentTime = Date.now()
		const elapsed = this.initialTime ? (currentTime - this.initialTime) / 1000 : 0
		const remainingTime = Math.max(0, Math.round(this.props.timer.remaining_time - elapsed))
		let color = 'green'
		if (remainingTime <= 0) {
			color = 'grey'
		} else if (remainingTime <= 10) {
			color = 'red'
		} else if (remainingTime <= 60) {
			color = 'yellow'
		}
		const time_text = timeFormat(remainingTime)
		this.setState({
			time_text,
			elapsed,
			color,
		})
		return remainingTime
	}

	componentDidUpdate(prevProps, prevState) {
		const stateToStopped =
			prevProps.timer.state !== timerStatusTypes.STOPPED
			&& this.props.timer.state === timerStatusTypes.STOPPED
		const remaningTimeChanged =
			prevProps.timer.remaining_time !== this.props.timer.remaining_time
		if (stateToStopped || remaningTimeChanged) {
			this.stopCountdown()
		}
		const stateToRunning =
			prevProps.timer.state !== timerStatusTypes.RUNNING
			&& this.props.timer.state === timerStatusTypes.RUNNING
			&& this.props.canStart
		const canStartToTrue = !prevProps.canStart
			&& this.props.canStart
		if (stateToRunning || canStartToTrue) {
			this.resumeCountdown()
		}
		if (prevState.color !== this.state.color && this.state.color !== '') {
			this.setState({
				animated: true,
			})
			setTimeout(this.deanimate, 2000)
		}
	}

	componentDidMount() {
		if (
			this.props.timer.state === timerStatusTypes.RUNNING
			&& this.props.canStart
		) {
			this.resumeCountdown()
		} else {
			this.setCurrentCountdown()
		}
	}

	render() {
		return (
			<div styleName={cn({
				wrapper: true,
				animated: this.state.animated,
			})}>
				<div styleName='time-vertical-up' >
					<div styleName='time-vertical-down'>
						<div styleName='time-horizontal-up'>
							<div styleName={cn({
								'time-horizontal-down': true,
								'time-horizontal-down--bg-yellow': this.state.color === 'yellow',
								'time-horizontal-down--bg-red': this.state.color === 'red',
								'time-horizontal-down--bg-grey': this.state.color === 'grey',
							})} >
								<span styleName='time'>{this.state.time_text}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

CountdownTimer.defaultProps = {
	animated: false,
	color: 'grey',
	timeText: '',
	timer: {
		remaining_time: 0,
	},
	onComplete: () => {},
}

CountdownTimer.propTypes = {
	animated: PropTypes.bool,
	timer: PropTypes.object,
	timeText: PropTypes.string,
	onComplete: PropTypes.func,
}

export default CSSModules(CountdownTimer, styles, {allowMultiple: true})
